var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import Button from '@doordash/component-button';
import { Colors, Spacing, StackChildren, Inset, Text, BorderRadius, Stack, } from '@doordash/design-language';
import styled from 'styled-components';
import ProductOptionsBenefitListCell from './ProductOptionsBenefitListCell';
import Separator from '@doordash/component-separator';
var TILE_MAX_WIDTH = 360;
var TILE_MAX_WIDTH_MOBILE = 340;
var TILE_MIN_HEIGHT = 360;
var TILE_MIN_HEIGHT_MOBILE = 350;
var SHORT_DIVIDER_WIDTH = 80;
var SHORT_DIVIDER_HEIGHT = 1;
export var TileContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: ", ";\n  background-color: ", ";\n  box-shadow: 0px 1px ", "px rgba(0, 0, 0, 0.2);\n  border-radius: ", "px;\n  max-width: ", "px;\n  min-height: ", "px;\n  display: inline-flex;\n  justify-content: center;\n  text-align: center;\n  padding: ", "px ", "px ", "px\n    ", "px;\n  margin-bottom: ", "px;\n  ", "\n  ", "\n"], ["\n  border-top: ", ";\n  background-color: ", ";\n  box-shadow: 0px 1px ", "px rgba(0, 0, 0, 0.2);\n  border-radius: ", "px;\n  max-width: ", "px;\n  min-height: ", "px;\n  display: inline-flex;\n  justify-content: center;\n  text-align: center;\n  padding: ", "px ", "px ", "px\n    ", "px;\n  margin-bottom: ", "px;\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var color = _a.color;
    return BorderRadius.Small + "px solid " + color;
}, Colors.BackgroundPrimary, Spacing.XxxSmall, Spacing.XxxSmall, TILE_MAX_WIDTH, TILE_MIN_HEIGHT, Spacing.XxLarge, Spacing.Large, Spacing.XLarge, Spacing.Large, Spacing.XxLarge, function (_a) {
    var isMobile = _a.isMobile;
    return !isMobile &&
        "\n    &:not(:last-child) {\n      margin-right: " + Spacing.XxxLarge + "px;\n    }\n  ";
}, function (_a) {
    var isMobile = _a.isMobile;
    return isMobile &&
        "\n    width: 100%;\n    max-width: " + TILE_MAX_WIDTH_MOBILE + "px;\n    min-height: " + TILE_MIN_HEIGHT_MOBILE + "px;\n    padding: " + Spacing.XLarge + "px " + Spacing.Small + "px " + Spacing.Small + "px " + Spacing.Small + "px;\n    margin-right: 0;\n    &(:last-child) {\n      margin-bottom: " + Spacing.Medium + "px;\n    }\n  ";
});
export var TitleCenteredText = styled(Text).attrs(function () { return ({
    styles: Text.Styles.Title2,
    textAlign: Text.TextAlignments.Center,
    color: Text.Colors.TextPrimary,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var BenefitDescListItem = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: left;\n  margin-left: 5%;\n"], ["\n  text-align: left;\n  margin-left: 5%;\n"])));
export var BenefitDescListContainer = styled.ul(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 0 ", "px;\n"], ["\n  padding: 0 ", "px;\n"])), Spacing.Large);
export var BodyCenteredText = styled(Text).attrs(function () { return ({
    styles: Text.Styles.Body2,
    weight: Text.Weights.Regular,
    textAlign: Text.TextAlignments.Center,
    color: Text.Colors.TextPrimary,
}); })(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
export var Divider = styled.hr(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: ", ";\n  width: ", ";\n  margin: ", ";\n  background-color: ", ";\n  border: none;\n  height: ", "px;\n"], ["\n  display: ",
    ";\n  width: ",
    ";\n  margin: ",
    ";\n  background-color: ", ";\n  border: none;\n  height: ", "px;\n"])), function (props) {
    return props.isShort ? 'inline-block' : 'block';
}, function (props) {
    return props.isShort ? SHORT_DIVIDER_WIDTH + "px" : 'auto';
}, function (props) {
    return props.isShort ? '0' : "0 -" + Spacing.Small + "px";
}, Colors.SystemGrey5, SHORT_DIVIDER_HEIGHT);
var TileHeader = styled(StackChildren).attrs(function () { return ({
    size: StackChildren.Sizes.XSmall,
}); })(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
var ProductOptionContentWithListCell = function (_a) {
    var listCellContent = _a.listCellContent, buttonText = _a.buttonText, callToAction = _a.callToAction;
    return (React.createElement(React.Fragment, null,
        listCellContent.map(function (content, index) { return (React.createElement("div", { key: content + "-" + index },
            React.createElement(Inset, { verticalSize: Inset.Sizes.Medium },
                React.createElement(Text, { styles: Text.Styles.Label1, textAlign: Text.TextAlignments.Left }, content.title)),
            React.createElement(Separator, { type: Separator.Types.InsetBorder }),
            React.createElement(ProductOptionsBenefitListCell, { benefitStrings: content.benefits, iconType: content.iconType }))); }),
        React.createElement(Button, { onClick: callToAction, type: Button.Types.Primary }, buttonText)));
};
var Detail = styled(Stack).attrs(function () { return ({
    size: Stack.Sizes.Small,
}); })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var PlanDetail = function (_a) {
    var planDetailData = _a.planDetailData;
    return (React.createElement(Detail, null,
        React.createElement(Text, { styles: Text.Styles.Body2 }, planDetailData.benefitName),
        React.createElement(Text, { styles: Text.Styles.Body2Emphasis }, planDetailData.detail)));
};
var ProductOptionTile = function (_a) {
    var isMobile = _a.isMobile, tileContent = _a.tileContent, hasListCell = _a.hasListCell, callToAction = _a.callToAction;
    return (React.createElement(TileContainer, { isMobile: isMobile, color: Colors.SystemRed40 },
        React.createElement(StackChildren, { size: StackChildren.Sizes.Small },
            React.createElement(TileHeader, { isMobile: isMobile },
                React.createElement(TitleCenteredText, null, tileContent.title),
                tileContent.subtitle && (React.createElement(BodyCenteredText, null, tileContent.subtitle)),
                React.createElement(Divider, { isShort: true })),
            tileContent.planDetails &&
                tileContent.planDetails.map(function (detail, index) { return (React.createElement(PlanDetail, { key: detail.benefitName + "-" + index, planDetailData: detail })); }),
            hasListCell ? (React.createElement(ProductOptionContentWithListCell, { listCellContent: tileContent.lists, buttonText: tileContent.buttonText, callToAction: callToAction })) : (React.createElement(StackChildren, { size: StackChildren.Sizes.Large },
                React.createElement(BenefitDescListContainer, null, tileContent.benefitList.map(function (description) { return (React.createElement(BenefitDescListItem, { key: description },
                    React.createElement(Text, { styles: Text.Styles.Body2Emphasis }, description))); })),
                React.createElement(Button, { type: Button.Types.Primary, onClick: callToAction }, tileContent.buttonText))))));
};
export default ProductOptionTile;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
